var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "68px",
    viewBox: "0 0 99 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropbox",
    fillRule: "nonzero",
    fill: "#007EE5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 5.000000)",
    id: "Dropbox_Logo_02"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "\\uC791\\uC5C5\\uC2E43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropbox_Logo_02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.019700, 0.008929)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "23.1975069 0.0354742919 0.139008939 15.1744867 16.082588 28.0130703 39.3326704 13.5766519"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0.139008939 40.8524094 23.1975069 55.9914218 39.3326704 42.4487333 16.082588 28.0130703"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "39.3326704 42.4487333 55.4678339 55.9914218 78.5263319 40.8524094 62.5827528 28.0130703"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "78.5263319 15.1744867 55.4678339 0.0354742919 39.3326704 13.5766519 62.5827528 28.0130703"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "39.380003 45.3626097 23.1975069 58.865258 16.2726698 54.3187948 16.2726698 59.4152456 39.380003 73.348516 62.4873363 59.4152456 62.4873363 54.3187948 55.5624992 58.865258"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.9b1d2afebb9250fae72ed2eeaad13540.svg";
export { ForwardRef as ReactComponent };